import StoreHelper from '../store/helper'
import DomHelper from './DomHelper'
import PositionManger from './PositionManager'

import _ from 'lodash'

class ResizeManager {
  constructor () {
    this.resizeObserver = null
  }

  observe(el) {
    this._init(el)
    this.resizeObserver.observe(el)
    return this
  }

  unobserve (el) {
    this.resizeObserver.unobserve(el)
  }

  _init (el) {
    if (_.isNull(this.resizeObserver)) {
      StoreHelper.setAppContainerSize(DomHelper.getMinSizeOfElement(el))
      this.resizeObserver = new ResizeObserver(this._onResize)
    }
  }

  _onResize (entries) {
    const menuResizeObserverEntry = _.find(entries, e => _.isEqual(e.target.id, 'b-menu-view__resize-observer'))
    const menuContentRect = _.get(menuResizeObserverEntry, 'contentRect', null)

    StoreHelper.setAppContainerSize(DomHelper.getMinSizeOfContentRect(menuContentRect))
    PositionManger.recalculateDragElementPositions(StoreHelper.getDragElements(StoreHelper.getActiveViewKey()))
  }
}

export default new ResizeManager()
